import { h } from "preact";
import { useState } from "preact/hooks";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";

import Alert from "../components/Alert.jsx";
import AppFooter from "../components/AppFooter.jsx";
import AppHeader from "../components/AppHeader.jsx";
import AppLayout from "../components/AppLayout.jsx";
import Button from "../components/Button.jsx";
import Checkbox from "../components/Checkbox.jsx";
import CheckboxGroup from "../components/CheckboxGroup.jsx";
import CurrencyField from "../components/CurrencyField.jsx";
import Datepicker from "../components/Datepicker.jsx";
import DocumentPreviewItem from "../components/DocumentPreviewItem.jsx";
import Dropdown from "../components/Dropdown.jsx";
import DropdownInput from "../components/DropdownInput.jsx";
import FilterBar from "../components/FilterBar.jsx";
import FilterPill from "../components/FilterPill.jsx";
import Icon from "../components/Icon.jsx";
import IconLink from "../components/IconLink.jsx";
import List from "../components/List.jsx";
import ListItem from "../components/ListItem.jsx";
import MultiSelect from "../components/MultiSelect.jsx";
import NioDropdown from "../components/NioDropdown.jsx";
import RadioButton from "../components/RadioButton.jsx";
import RadioButtonGroup from "../components/RadioButtonGroup.jsx";
import SecondaryNavi from "../components/SecondaryNavi.jsx";
import SegmentedControl from "../components/SegmentedControl.jsx";
import Slider from "../components/Slider.jsx";
import Stars from "../components/Stars.jsx";
import StateIcon from "../components/StateIcon.jsx";
import SubmitButton from "../components/SubmitButton.jsx";
import Tag from "../components/Tag.jsx";
import TalentListItem from "../components/TalentListItem.jsx";
import TalentState from "../components/TalentState.jsx";
import TaskFilter from "../components/TaskFilter.jsx";
import TaskListItem from "../components/TaskListItem.jsx";
import TaskProgressFilter from "../components/TaskProgressFilter.jsx";
import TextArea from "../components/TextArea.jsx";
import TextField from "../components/TextField.jsx";
import Hint from "../components/Hint.jsx";
import UploadField from "../components/UploadField.jsx";
import { addHighlightSpans, renderHtml } from "../helpers.js";
import CompensationRange from "../components/CompensationRange.jsx";
import { showCompensationRange } from "../services/compensationRange.js";

export default function ShowcasePage() {
  const [loading, setLoading] = useState(false);
  const [currentMoney, setCurrentMoney] = useState("");
  const [currentMoney2, setCurrentMoney2] = useState("");
  const [currentTextValue, setCurrentTextValue] = useState("");
  const [currentTextValue2, setCurrentTextValue2] = useState("");
  const [radio1, setRadio1] = useState(false);
  const [radio2, setRadio2] = useState("r2");
  const [radio3, setRadio3] = useState(false);
  const [radioGroup, setRadioGroup] = useState("");
  const [radioGroup2, setRadioGroup2] = useState("");
  const [check1, setCheck1] = useState(false);
  const [check2, setCheck2] = useState(false);
  const [checkGroup, setCheckGroup] = useState([]);
  const [checkGroup2, setCheckGroup2] = useState([]);
  const [multiSelectValue, setMultiSelectValue] = useState([]);
  const [multiSelectValue2, setMultiSelectValue2] = useState([]);
  const [date1, setDate1] = useState(null);
  const [date2, setDate2] = useState("24/12/2022");
  const [saveButton, setSaveButton] = useState("idle");
  const [sliderValue, setSliderValue] = useState(50);
  const [dropdownValue, setDropdownValue] = useState("");
  const [yearsSliderValue, setYearsSliderValue] = useState(1);
  const [rangeSliderValue, setRangeSliderValue] = useState([25, 75]);
  const [nioDropdownItems, setNioDropdownItems] = useState(["War and Peace"]);
  const [
    compensationRangeYearsSliderValue,
    setCompensationRangeYearsSliderValue,
  ] = useState(5);
  const [compensationRangeSliderValue, setCompensationRangeSliderValue] =
    useState([25, 75]);

  const selectionItems = [
    {
      value: "one",
      label: "One",
      description: "This is optional.",
    },
    { value: "two", label: "Two" },
    { value: "three", label: "Three" },
    {
      value: "fortytwo",
      label: "Fortytwo",
      description: "That’s the number.",
    },
  ];

  const docs = [
    {
      title: "The thing to have",
      size: "10 MB",
      src: "https://docs.google.com/spreadsheets/d/15Dv_H6hCtNVxSjI36Vgr7UGZLJoHdZ8PjbAkfi2IvV4/edit",
    },
  ];
  const tasks = [];
  const hint = {
    id: "email_confirmed",
    title: "A great Hint",
    description: "Is something that helps you out when in need.",
    actionText: "Click me",
    action: {
      type: "CLICKING",
    },
    placeholders: { email: "my@email.io" },
  };

  const books = [
    { author: "Harper Lee", title: "To Kill a Mockingbird" },
    { author: "Lev Tolstoy", title: "War and Peace" },
    { author: "Fyodor Dostoyevsy", title: "The Idiot" },
    { author: "Oscar Wilde", title: "A Picture of Dorian Gray" },
    { author: "George Orwell", title: "1984" },
    { author: "Jane Austen", title: "Pride and Prejudice" },
    { author: "Marcus Aurelius", title: "Meditations" },
    { author: "Fyodor Dostoevsky", title: "The Brothers Karamazov" },
    { author: "Lev Tolstoy", title: "Anna Karenina" },
    { author: "Fyodor Dostoevsky", title: "Crime and Punishment" },
  ];

  const possibleDropdownItems = books.map(({ author, title }) => ({
    filter: (needle) => title.toLowerCase().indexOf(needle) > -1,
    value: title,
    content: (needle) => (
      <div>
        {renderHtml(addHighlightSpans(title, needle))}
        <br />
        by {author}
      </div>
    ),
    selected: nioDropdownItems.indexOf(title) > -1,
  }));
  const possibleDropdownItemsPlain = books.map(({ author, title }) => ({
    value: title,
    text: title,
    selected: nioDropdownItems.indexOf(title) > -1,
  }));

  function toggleNioDropdownItems({ selected, value }) {
    if (selected) {
      setNioDropdownItems(nioDropdownItems.filter((x) => x !== value));
    } else {
      setNioDropdownItems([...nioDropdownItems, value]);
    }
  }

  let possibleMoneyValues = [];
  for (let i = 0; i < 151001; i = i + 1000) {
    possibleMoneyValues.push(i);
  }

  return (
    <AppLayout
      loading={loading}
      headerWithFilter
      header={
        <AppHeader
          title="Showcase of all the Components"
          showIcon
          filterBar={
            <FilterBar>
              <TaskProgressFilter />
              <TaskFilter tasks={[]} />
            </FilterBar>
          }
        >
          <SecondaryNavi
            items={[
              { text: "Stuff", to: "/app/showcase" },
              { text: "Somewhere", to: "/app/somewhere" },
            ]}
          />
        </AppHeader>
      }
      footer={<AppFooter />}
    >
      <div>
        <Hint hint={hint} onAction={(action) => alert(action.type)} />
        <Checkbox
          onChange={(event) => {
            setLoading(event.target.checked);
          }}
          {...(loading ? { checked: "checked" } : {})}
        >
          Show page loading indicator
        </Checkbox>
        <Alert error>Something bad happened. Dang it.</Alert>
        <Alert info>Something bad happened. Dang it.</Alert>

        {tasks.map((task) => (
          <TaskListItem task={task} />
        ))}
        <h6 class="t-h5 t-h5--margin">Links</h6>
        <p>
          Generate Lorem Ipsum placeholder text for use in your{" "}
          <a href="#">graphic</a>, print and web layouts, and discover plugins
          for your favorite writing, design and blogging tools. And this is a{" "}
          <a href="#" class="subtle">
            subtle link
          </a>
          . Explore the origins, history and meaning of the famous passage, and
          learn how Lorem Ipsum went from scrambled Latin passage to ubiqitous
          dummy text.
        </p>
        <p>
          DEPRECATED:
          <IconLink href="/app/showcase" iconFront="language">
            Test icon link in front
          </IconLink>
          <IconLink href="/app/showcase" iconBack="favorite">
            Test icon link behind
          </IconLink>
        </p>
        <div class="row row--unpadded mt-2">
          {docs.map((doc) => (
            <div class="col s4">
              <DocumentPreviewItem document={doc} />
            </div>
          ))}
        </div>
        <h6 class="t-h5 t-h5--margin">List</h6>
        <List>
          <ListItem number={1}>One</ListItem>
          <ListItem number={2}>
            Lorem ipsum dolor sit amet consectetur adipisicing elit.
          </ListItem>
          <ListItem overline="Overlined">
            Lorem ipsum dolor sit amet consectetur adipisicing elit.
          </ListItem>
          <ListItem iconFront="favorite">Die Macht erwacht</ListItem>
          <ListItem iconBack="favorite">Die Macht erwacht</ListItem>
          <ListItem iconFront="favorite" iconBack="favorite">
            Die Macht erwacht
          </ListItem>

          <ListItem
            iconFront="favorite"
            iconBack="favorite"
            secondLine="Die Macht erwacht"
          >
            Star Wars
          </ListItem>
          <ListItem secondLine="Sein oder nicht Sein">Hamlet</ListItem>
          <ListItem bold secondLine="Sein oder nicht Sein">
            Bold Hamlet
          </ListItem>
        </List>
        <h6 class="t-h5 t-h5--margin">Segmented Control</h6>
        <SegmentedControl
          items={[
            {
              text: "Foo",
              onClick: () => {
                console.log("CLicked Foo");
              },
            },
            { text: "Middle", to: "/app/showcase", active: true },
            { text: "Form", to: "#form" },
          ]}
        />
        <Tabs>
          <TabList className="segmented-control">
            <Tab
              className="segmented-control__item"
              selectedClassName="segmented-control__item--active"
            >
              Title 1
            </Tab>
            <Tab
              className="segmented-control__item"
              selectedClassName="segmented-control__item--active"
            >
              Title 2
            </Tab>
          </TabList>

          <TabPanel>
            <div>Any content 1</div>
          </TabPanel>
          <TabPanel>
            <div>Any content 2</div>
          </TabPanel>
        </Tabs>
        <h6 class="t-h5 t-h5--margin">Talent List items</h6>
        <TalentListItem
          user={{
            name: "John Doe",
            company: "Twitter",
            position: "Gangster",
            country: "IN",
            countryName: "India",
          }}
          big
        />
        <TalentListItem
          user={{
            name: "John Doe",
            company: "Twitter",
            position: "Gangster",
            country: "IN",
            countryName: "India",
          }}
        />
        <TalentListItem
          noAvatar
          user={{
            name: "John Doe",
            position: "Gangster",
            country: "IN",
            countryName: "India",
          }}
          big
        />
        <TalentListItem
          noAvatar
          user={{
            name: "John Doe",
            position: "Gangster",
            country: "IN",
            countryName: "India",
          }}
        />
        <h6 class="t-h5 t-h5--margin">Talent states</h6>
        {[
          "not_interacted",
          "requested",
          "request_accepted",
          "request_declined",
          "contacted",
          "contacted",
          "replied",
          "screened",
          "declined",
          "hired",
        ].map((state) => (
          <TalentState class="mr-16 mb-8" talent={{ state }} />
        ))}
        <h6 class="t-h5 t-h5--margin">Buttons</h6>
        <p>
          <Button class="mr-16">Simple</Button>
          <Button class="mr-16" iconFront="favorite">
            Icon left
          </Button>
          <Button class="mr-16" iconBack={<Icon>fast_forward</Icon>}>
            Icon right
          </Button>
          <Button class="mr-16" iconFront="fast_forward" iconBack="fast_rewind">
            Icon both sides
          </Button>
          <Button disabled class="mr-16">
            Simple
          </Button>
        </p>
        <p>
          <Button small class="mr-16">
            Small
          </Button>
          <Button small class="mr-16" iconFront="fast_rewind">
            Icon left
          </Button>
          <Button small class="mr-16" iconBack="favorite">
            Icon right
          </Button>
          <Button
            small
            class="mr-16"
            iconFront="fast_rewind"
            iconBack="fast_forward"
          >
            Icon both sides
          </Button>
          <Button disabled small class="mr-16">
            Small
          </Button>
        </p>
        <p>
          <Button outlined class="mr-16">
            Outlined
          </Button>
          <Button outlined class="mr-16" iconFront="favorite">
            Icon left
          </Button>
          <Button outlined class="mr-16" iconBack={<Icon>fast_forward</Icon>}>
            Icon right
          </Button>
          <Button
            outlined
            class="mr-16"
            iconFront="fast_forward"
            iconBack="fast_rewind"
          >
            Icon both sides
          </Button>
          <Button disabled outlined class="mr-16">
            Outlined
          </Button>
        </p>
        <p>
          <Button outlined small class="mr-16">
            outlined
          </Button>
          <Button outlined small class="mr-16" iconFront="fast_rewind">
            Icon left
          </Button>
          <Button outlined small class="mr-16" iconBack="favorite">
            Icon right
          </Button>
          <Button
            outlined
            small
            class="mr-16"
            iconFront="fast_rewind"
            iconBack="fast_forward"
          >
            Icon both sides
          </Button>
          <Button disabled outlined small class="mr-16">
            outlined
          </Button>
        </p>
        <p>
          <Button secondary class="mr-16">
            Secondary
          </Button>
          <Button secondary class="mr-16" iconFront="favorite">
            Icon left
          </Button>
          <Button secondary class="mr-16" iconBack={<Icon>fast_forward</Icon>}>
            Icon right
          </Button>
          <Button
            secondary
            class="mr-16"
            iconFront="fast_forward"
            iconBack="fast_rewind"
          >
            Icon both sides
          </Button>
          <Button disabled secondary class="mr-16">
            secondary
          </Button>
        </p>
        <p>
          <Button secondary small class="mr-16">
            Secondary
          </Button>
          <Button secondary small class="mr-16" iconFront="fast_rewind">
            Icon left
          </Button>
          <Button secondary small class="mr-16" iconBack="favorite">
            Icon right
          </Button>
          <Button
            secondary
            small
            class="mr-16"
            iconFront="fast_rewind"
            iconBack="fast_forward"
          >
            Icon both sides
          </Button>
          <Button disabled secondary small class="mr-16">
            secondary
          </Button>
        </p>
        <p>
          <Button text noIndent class="mr-16">
            Text
          </Button>
          <Button text class="mr-16" iconFront="favorite">
            Icon left
          </Button>
          <Button text class="mr-16" iconBack={<Icon>fast_forward</Icon>}>
            Icon right
          </Button>
          <Button
            text
            class="mr-16"
            iconFront="fast_forward"
            iconBack="fast_rewind"
          >
            Icon both sides
          </Button>
          <Button disabled text class="mr-16">
            Text
          </Button>
        </p>
        <p>
          <Button text noIndent small class="mr-16">
            text
          </Button>
          <Button text small class="mr-16" iconFront="fast_rewind">
            Icon left
          </Button>
          <Button text small class="mr-16" iconBack="favorite">
            Icon right
          </Button>
          <Button
            text
            small
            class="mr-16"
            iconFront="fast_rewind"
            iconBack="fast_forward"
          >
            Icon both sides
          </Button>
          <Button disabled text small class="mr-16">
            small print
          </Button>
        </p>
        <p>
          <SubmitButton
            sending={saveButton === "loading"}
            success={saveButton === "success"}
            onClick={() => {
              setSaveButton("loading");
              setTimeout(() => {
                setSaveButton("success");
                setTimeout(() => {
                  setSaveButton("idle");
                }, 2500);
              }, 1000);
            }}
          >
            Save me
          </SubmitButton>
        </p>
        <h6 class="t-h5 t-h5--margin mt-2">Filter Pills</h6>
        <p>
          <FilterPill class="mr-16">Select me</FilterPill>
          <FilterPill count={2} class="mr-16">
            Select me
          </FilterPill>
          <FilterPill selected>Select me</FilterPill>
        </p>
        <h6 class="t-h5 t-h5--margin mt-2">Tags</h6>
        <p>
          <Tag class="mr-16">First</Tag>
          <Tag iconFront="cloud_queue" class="mr-16">
            Things
          </Tag>
          <Tag iconBack="favorite" class="mr-16">
            First
          </Tag>
        </p>
        <p>
          <Tag text noIndent class="mr-16">
            First
          </Tag>
          <Tag text iconFront="favorite" class="mr-16">
            Things
          </Tag>
          <Tag text iconBack="cloud_queue" class="mr-16">
            First
          </Tag>
        </p>
        <p>
          <Tag to="/showcase#1" noIndent class="mr-16">
            First
          </Tag>
          <Tag to="/showcase#2" iconFront="favorite" class="mr-16">
            Things
          </Tag>
          <Tag to="/showcase#3" iconBack="cloud_queue" class="mr-16">
            First
          </Tag>
        </p>
        <div class="row row--unpadded">
          <div class="col s3">
            <h6 class="t-h5 t-h5--margin mt-2">Ratings</h6>
            <Stars rating={0} />
            <br />
            <Stars rating={0.5} />
            <br />
            <Stars rating={1} />
            <br />
            <Stars rating={1.5} />
            <br />
            <Stars rating={2} />
            <br />
            <Stars rating={2.5} />
            <br />
            <Stars rating={3} />
          </div>
          <div class="col s3">
            <h6 class="t-h5 t-h5--margin mt-2"></h6>
            <Stars tiny rating={0} />
            <br />
            <Stars tiny rating={0.5} />
            <br />
            <Stars tiny rating={1} />
            <br />
            <Stars tiny rating={1.5} />
            <br />
            <Stars tiny rating={2} />
            <br />
            <Stars tiny rating={2.5} />
            <br />
            <Stars tiny rating={3} />
          </div>
          <div class="col s3">
            <h6 class="t-h5 t-h5--margin mt-2">State icons</h6>
            <StateIcon state="done" class="mr-16" />
            <StateIcon state="ready" class="mr-16" />
            <StateIcon state="in progress" class="mr-16" />
            <StateIcon state="blocked" class="mr-16" />
          </div>
        </div>
        <a id="form"></a>
        <h6 class="t-h5 t-h5--margin mt-2">Form fields</h6>
        <div class="row row--unpadded">
          <div class="col s6">
            <CurrencyField
              label="Put in your money"
              id="money-field"
              name="money"
              min="0"
              value={currentMoney}
              currency="€"
              onChange={setCurrentMoney}
              info={`You entered: ${currentMoney}`}
            />
          </div>
          <div class="col s6">
            <TextField
              placeholder="Just a placeholder, no label"
              id="just-a-field"
              name="text"
              value={currentTextValue}
              info={`You entered: ${currentTextValue}`}
              onUpdate={setCurrentTextValue}
            />
          </div>
          <div class="col s6">
            <CurrencyField
              label="Put in more money"
              id="more-money-field"
              name="money"
              min="0"
              value={currentMoney2}
              currency="€"
              onChange={setCurrentMoney2}
              iconBefore="mail"
            />
          </div>
          <div class="col s6">
            <TextField
              label="This is definitely broken"
              id="just-another-field"
              name="text"
              value={currentTextValue2}
              onUpdate={setCurrentTextValue2}
              iconBefore="mail"
              iconAfter="phone"
              info="Just be nice"
            />
          </div>
          <div class="col s6">
            <CurrencyField
              label="Put in more money"
              id="even-more-money-field"
              name="money"
              min="0"
              currency="€"
              iconBefore="mail"
              error="Foo bar"
            />
          </div>
          <div class="col s6">
            <TextField
              label="This is definitely broken"
              id="and-another-field"
              name="text"
              value="buja"
              iconAfter="phone"
              error="Foo bar"
            />
          </div>
          <div class="col s6">
            <TextArea
              label="Write as much as you want"
              id="and-a-textarea"
              name="textarea"
              value="buja"
              iconBefore="phone"
            />
          </div>
          <div class="col s6">
            <UploadField
              label="Select a file to upload"
              info="Please only PDF"
              id="pdf-field"
              iconBefore="cloud"
              uploading
            />
          </div>

          <div class="col s6">
            <Datepicker
              label="Please choose a date"
              id="date-picker1"
              name="date-picker1"
              error="It's not broken, just looks like it ;-)"
              onChange={setDate1}
            />
            <p>Chosen date: {date1 && date1.toString()}</p>
          </div>

          <div class="col s6">
            <Datepicker
              label="Please choose a future date"
              id="date-picker2"
              name="date-picker2"
              min="today"
              onChange={setDate2}
              value={date2}
            />
            <p>Chosen date: {date2 && date2.toString()}</p>
          </div>

          <div class="col s6">
            <p>
              <RadioButton
                id="radio1"
                name="radio1"
                value="r1"
                class="mt-2"
                onChange={(event) => {
                  setRadio1(event.target.checked ? event.target.value : false);
                }}
                checked={radio1 === "r1"}
              >
                I am a label
              </RadioButton>
            </p>

            <p>
              <RadioButton
                id="radio2"
                name="radio2"
                value="r2"
                class="mt-2"
                onChange={(event) => {
                  setRadio2(event.target.checked ? event.target.value : false);
                }}
                checked={radio2 === "r2"}
              >
                I am initially checked
              </RadioButton>
            </p>

            <RadioButtonGroup
              id="radio-group"
              name="radio-group"
              items={selectionItems}
              class="mt-2"
              onChange={(event) => {
                setRadioGroup(event.target.value);
              }}
              value={radioGroup}
            />
            <p>Selected Value: {radioGroup || "none"}</p>
          </div>
          <div class="col s6">
            <p>
              <RadioButton
                boxed
                id="radio3"
                name="radio3"
                value="r3"
                class="mt-2"
                onChange={(event) => {
                  setRadio3(event.target.checked ? event.target.value : false);
                }}
                checked={radio3 === "r3"}
                description="Just a note"
              >
                Select me
              </RadioButton>
            </p>

            <RadioButtonGroup
              boxed
              id="radio-group2"
              name="radio-group2"
              items={selectionItems}
              class="mt-2"
              onChange={(event) => {
                setRadioGroup2(event.target.value);
              }}
              value={radioGroup2}
            />
            <p>Selected Value: {radioGroup2}</p>
          </div>

          <div class="col s6">
            <Checkbox
              id="check"
              name="check"
              onChange={(event) => {
                setCheck1(event.target.value);
              }}
              description="And I am a note"
              value={check1}
            >
              I am a checkbox
            </Checkbox>

            <CheckboxGroup
              id="check-group1"
              name="check-group1"
              items={selectionItems}
              class="mt-2"
              onChange={(event) => {
                if (event.target.checked) {
                  setCheckGroup([...checkGroup, event.target.value]);
                } else {
                  setCheckGroup(
                    checkGroup.filter((x) => x != event.target.value)
                  );
                }
              }}
              value={checkGroup}
            >
              I am initially checked
            </CheckboxGroup>
            <p>Selected checkbox: {checkGroup.join(", ") || "none"}</p>

            <h6 class="t-h5 t-h5--margin">Slider</h6>
            <Slider
              value={sliderValue}
              onChange={setSliderValue}
              min={25}
              max={100}
            />
            <p>Value: {sliderValue}</p>

            <Slider
              value={rangeSliderValue}
              onChange={setRangeSliderValue}
              min={1}
              max={100}
            />
            <p>
              Value: {rangeSliderValue[0]}-{rangeSliderValue[1]}
            </p>

            <Slider
              value={yearsSliderValue}
              onChange={setYearsSliderValue}
              possibleValues={[
                "0 Years",
                "1 Year",
                "2 Years",
                "3 Years",
                ">3 Years",
              ]}
            />
            <p>Value: {yearsSliderValue}</p>

            <h6 class="t-h5 t-h5--margin">Dropdown</h6>
            <Dropdown
              items={selectionItems.map(({ value }) => ({
                text: value,
                value,
              }))}
              onClick={setDropdownValue}
            >
              <DropdownInput label="Select from Dropdown">
                {dropdownValue}
              </DropdownInput>
            </Dropdown>
          </div>

          <div class="col s6">
            <h6 class="t-h5 t-h5--margin">w/ icons</h6>
            <Checkbox
              id="check2"
              name="check2"
              onChange={(event) => {
                setCheck2(event.target.value);
              }}
              description="And I am a note"
              value={check2}
              iconFront="favorite"
              iconBack="favorite"
            >
              I am a checkbox
            </Checkbox>

            <CheckboxGroup
              id="check-group2"
              name="check-group2"
              items={selectionItems.map((x) => ({
                ...x,
                iconFront: "favorite",
                iconBack: "favorite",
              }))}
              class="mt-2"
              onChange={(event) => {
                if (event.target.checked) {
                  setCheckGroup2([...checkGroup2, event.target.value]);
                } else {
                  setCheckGroup2(
                    checkGroup2.filter((x) => x != event.target.value)
                  );
                }
              }}
              value={checkGroup2}
            >
              I am initially checked
            </CheckboxGroup>
            <p>Selected Value: {checkGroup2.join(", ")}</p>

            <h6 class="t-h5 t-h5--margin">Multiselect:</h6>
            <MultiSelect
              onlySuggestions
              suggestions={selectionItems.map(({ value }) => ({
                text: value,
                value,
              }))}
              class="mt-2"
              id="multiselect"
              name="multiselect"
              label="Only suggested values"
              onChange={(value) => {
                setMultiSelectValue([...multiSelectValue, value]);
              }}
              onRemove={(value) => {
                console.log("remove", value);
                setMultiSelectValue(multiSelectValue.filter((x) => x != value));
              }}
              values={multiSelectValue}
            ></MultiSelect>

            <MultiSelect
              suggestions={selectionItems.map(({ value }) => ({
                text: value,
                value,
              }))}
              max={2}
              class="mt-2"
              id="multiselect"
              name="multiselect"
              label="Any value permitted"
              onChange={(value) => {
                setMultiSelectValue2([...multiSelectValue2, value]);
              }}
              onRemove={(value) => {
                setMultiSelectValue2(
                  multiSelectValue2.filter((x) => x != value)
                );
              }}
              values={multiSelectValue2}
            ></MultiSelect>
          </div>
        </div>
        <div class="row">
          <div class="col s6">
            <h6 class="t-h5 t-h5--margin">New Nio Dropdown</h6>
            <span style="display: inline-block; margin-right: 1rem">
              <NioDropdown
                withFilter
                items={possibleDropdownItems}
                trigger={(getTriggerProps) => (
                  <span {...getTriggerProps({}, { suppressRefError: true })}>
                    klick me
                  </span>
                )}
                placeholder="Something…"
                onSelect={toggleNioDropdownItems}
              ></NioDropdown>
            </span>
            <span style="display: inline-block;">
              <NioDropdown
                withFilter
                items={possibleDropdownItemsPlain}
                trigger={(getTriggerProps) => (
                  <span {...getTriggerProps({}, { suppressRefError: true })}>
                    Plain Text
                  </span>
                )}
                placeholder="Something…"
                onSelect={toggleNioDropdownItems}
              ></NioDropdown>
            </span>
            <p>
              Selected:
              {nioDropdownItems.map((x) => (
                <Tag>{x}</Tag>
              ))}
            </p>
          </div>
          <div class="col s6">
            <h6 class="t-h5 t-h5--margin">Compensation Range</h6>
            <div>
              Normal:
              {showCompensationRange({
                compensationRange: [10000, 70000],
                yearsOfWorkExperience: 3,
              }) && (
                <CompensationRange
                  class="color-brand-jade ml-8"
                  range={[10000, 70000]}
                />
              )}
            </div>
            <div>
              no max bound:
              {showCompensationRange({
                compensationRange: [25000, 151000],
                yearsOfWorkExperience: 5,
              }) && (
                <CompensationRange
                  class="color-brand-jade ml-8"
                  range={[25000, 151000]}
                />
              )}
            </div>
            <div>
              High salary & not enough exp:
              {showCompensationRange({
                compensationRange: [91000, 110000],
                yearsOfWorkExperience: 3,
              }) && (
                <CompensationRange
                  class="color-brand-jade ml-8"
                  range={[91000, 110000]}
                />
              )}
            </div>
            <div>
              High salary & enough exp:
              {showCompensationRange({
                compensationRange: [91000, 110000],
                yearsOfWorkExperience: 4,
              }) && (
                <CompensationRange
                  class="color-brand-jade ml-8"
                  range={[91000, 110000]}
                />
              )}
            </div>
            <div>
              To less salary asked
              {showCompensationRange({
                compensationRange: [10000, 24000],
                yearsOfWorkExperience: 3,
              }) && (
                <CompensationRange
                  class="color-brand-jade ml-8"
                  range={[10000, 24000]}
                />
              )}
            </div>
            <div>
              full width:
              {showCompensationRange({
                compensationRange: [0, 151000],
                yearsOfWorkExperience: 7,
              }) && (
                <CompensationRange
                  class="color-brand-jade ml-8"
                  range={[0, 151000]}
                />
              )}
            </div>
            <div class="mt-16">
              <b>Playful example:</b>{" "}
              {showCompensationRange({
                compensationRange: compensationRangeSliderValue.map(
                  (x) => x * 1000
                ),
                yearsOfWorkExperience: [0, 1, 3, 4, 5, 6, 7, 10, 15][
                  compensationRangeYearsSliderValue
                ],
              }) && (
                <CompensationRange
                  class="color-brand-jade ml-8"
                  range={compensationRangeSliderValue.map((x) => x * 1000)}
                  user={{
                    yearsOfWorkExperience: [0, 1, 3, 4, 5, 6, 7, 10, 15][
                      compensationRangeYearsSliderValue
                    ],
                  }}
                />
              )}
              <p>
                Compensation Range:
                <Slider
                  value={compensationRangeSliderValue}
                  onChange={setCompensationRangeSliderValue}
                  possibleValues={possibleMoneyValues}
                  range
                  minDistance={5}
                />
              </p>
              <p>
                Years of Exp:{" "}
                <Slider
                  value={compensationRangeYearsSliderValue}
                  onChange={setCompensationRangeYearsSliderValue}
                  possibleValues={[0, 1, 3, 4, 5, 6, 7, 10, 15]}
                />
              </p>
            </div>
          </div>
        </div>
      </div>
    </AppLayout>
  );
}
